import { useHeatReportContext } from "@/pages/heat-report/context/HeatReportContext";
import { Grid } from "@mui/material";
import { HeaderData } from "./components/HeaderData";
import { ProbesTable } from "./components/tables/probes-table/ProbesTable";
import { StrandsTable } from "./components/tables/strands-table/StrandsTable";
import { MultiLineChart } from "@/shared/charts/MultiLineChart";
import { TorchesTable } from "./components/tables/torches-table/TorchesTable";
import { LengthTable } from "./components/tables/length-table/LengthTable";
import { BilletsYardTable } from "./components/tables/billets-yard-table/BilletsYardTable";

export const CasterProcessData = () => {
  const {
    state: { casProcessData, strandSpeeds, moldLevels },
  } = useHeatReportContext();
  return (
    <>
      <Grid item xs={12} container spacing={2} justifyContent="center">
        <Grid item xs={12}>
          <HeaderData key={casProcessData.ProcessId} />
        </Grid>
      </Grid>

      <Grid item xs={12} container spacing={2} justifyContent="center">
        <Grid item xs={12} sm={6} md={6}>
          <LengthTable key={casProcessData.ProcessId} />
        </Grid>
        <Grid item xs={12} sm={6} md={6}>
          <BilletsYardTable key={casProcessData.ProcessId} />
        </Grid>
        <Grid item xs={12}>
          <TorchesTable key={casProcessData.ProcessId} />
        </Grid>
        <Grid item xs={12} sm={3} md={3}>
          <ProbesTable key={casProcessData.ProcessId} />
        </Grid>
        <Grid item xs={12} sm={9} md={9}>
          <StrandsTable key={casProcessData.ProcessId} />
        </Grid>
        <Grid item xs={12} sm={6} md={6}>
          <MultiLineChart
            key={casProcessData.ProcessId}
            title={"Strands Speed"}
            data={strandSpeeds ?? []}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={6}>
          <MultiLineChart
            key={casProcessData.ProcessId}
            title={"Mold Levels"}
            data={moldLevels ?? []}
          />
        </Grid>
      </Grid>
    </>
  );
};
